import type {
  ISegmentedBannerListItem,
  TCreateBannerParams,
  TDeleteBannerParams,
  TToggleBannerParams,
  TUpdateBannerParams,
} from 'core/model/interfaces/banners';
import { bannersData } from './banners.data';
import type {
  IGetBannerBySegmentGroupListParams,
  IGetBannerListParams,
  IGetSegmentedBannerCarouselListParams,
} from './banners.dto';
import {
  toCreateBanner,
  toGetBannerCarouselList,
  toGetBannerListByTarget,
  toMapBannerCarouselListParams,
  toMapBannerListByTargetParams,
  toMapPublishSegmentedBannerListParams,
  toToggleBanner,
  toUpdateBanner,
} from './banners.mappers';

export const bannersService = {
  getBannerCarouselList: async (params: IGetSegmentedBannerCarouselListParams) => {
    const newParams = toMapBannerCarouselListParams(params);

    const response = await bannersData.getBannerCarouselList(newParams);

    const mappedResponse = toGetBannerCarouselList(response);

    return mappedResponse;
  },
  getBannerListByTarget: async (params: IGetBannerListParams) => {
    const newParams = toMapBannerListByTargetParams(params);

    const response = await bannersData.getBannerListByTarget(newParams);

    const mappedResponse = toGetBannerListByTarget(response);

    return mappedResponse;
  },
  getBannerBySegmentGroupList: async (params: IGetBannerBySegmentGroupListParams) => {
    const response = await bannersData.getBannerBySegmentGroupList(params);

    return response;
  },
  createBanner: async (params: TCreateBannerParams) => {
    const formData = toCreateBanner(params);

    const response = await bannersData.createBanner(params, formData);

    return response;
  },
  updateBanner: async (params: TUpdateBannerParams) => {
    const formData = toUpdateBanner(params);

    const response = await bannersData.updateBanner(params, formData);

    return response;
  },
  toggleBanner: async (params: TToggleBannerParams) => {
    const formData = toToggleBanner(params);

    const response = await bannersData.toggleBanner(params, formData);

    return response;
  },
  deleteBanner: async (params: TDeleteBannerParams) => {
    const response = await bannersData.deleteBanner(params);

    return response;
  },
  publishSegmentedBannerList: async (params: ISegmentedBannerListItem) => {
    const newParams = toMapPublishSegmentedBannerListParams(params);

    const response = await bannersData.publishSegmentedBannerList(newParams);

    return response;
  },
};
